module.exports = __webpack_public_path__ + "static/media/gallery.8283205b.svg";